module.exports = __webpack_public_path__ + "img/6.e3994d6f.png";